export const SET_CALL_DETAIL = "SET_CALL_DETAIL";
export const CLEAR_CALL_DETAIL = "CLEAR_CALL_DETAIL";

export const setCallDetail = (id, date,name) => {
  return {
    type: SET_CALL_DETAIL,
    payload: { id, date,name}
  };
};

export const clearCallDetail = () => {
  return {
    type: CLEAR_CALL_DETAIL
  };
};
